import { Theme } from '@mui/material/styles';

export const countdownCardStyles = (theme: Theme, imagePath?: string) => ({
  countdown: {
    height: 'calc(100vh - 346px)',
    mx: 3,
    [theme.breakpoints.up('xl')]: { height: 'calc(100vh - 400px)' },
    [theme.breakpoints.down('md')]: { mx: 2, height: 'calc(100vh - 350px)' },
    [theme.breakpoints.down('sm')]: { mx: 0, height: 'calc(100vh - 506px)' }
  },
  gifMaskBox: {
    display: 'flex',
    justifyContent: 'center',
    maskImage: `url(${imagePath})`,
    maskRepeat: 'no-repeat',
    maskPosition: 'center',
    maskSize: 'contain',
    height: '100%',
    width: '100%',
    zIndex: 0
  },
  countdownText: {
    display: 'flex',
    justifyContent: 'center',
    alignºItems: 'center',
    height: '100%',
    mx: 0,
    width: '100%'
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      height: '180px'
    }
  },
  svgIcon: {
    width: '100%',
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      mr: 3
    }
  },
  countdownContainer: {
    position: 'relative',
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      height: '185px'
    }
  },
  countdownMask: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    maskImage: `url(${imagePath})`,
    maskRepeat: 'no-repeat',
    backgroundColor: '#706868',
    maskSize: 'contain',
    maskPosition: 'center'
  },
  textMaskImage: {
    position: 'absolute',
    zIndex: 10
  },
  countdownCompletedSubtitle: {
    textAlign: 'center',
    fontVariationSettings: "'wght' 500",
    [theme.breakpoints.up('xl')]: {
      fontSize: '50px',
      fontVariationSettings: "'wght' 400"
    },
    [theme.breakpoints.up('md')]: {
      mb: 4
    },
    [theme.breakpoints.up('sm')]: {
      mb: 2
    },
    [theme.breakpoints.up('xs')]: {
      mb: 2
    }
  },
  countdownCompletedTitle: {
    textAlign: 'center',
    fontVariationSettings: "'wght' 400",
    [theme.breakpoints.up('xl')]: {
      fontSize: '40px'
    },
    [theme.breakpoints.up('md')]: {
      pb: 5
    },
    [theme.breakpoints.up('sm')]: {
      pb: 4
    },
    [theme.breakpoints.up('xs')]: {
      pb: 2
    }
  },
  gif: {
    opacity: '50%'
  }
});
